import type { NavigationGuardNext, RouteLocationNormalized, RouteRecordName, RouteRecordRaw } from "vue-router";

const Checkout = () => import("@/pages/checkout/index.vue");
// Innovadis custom: Removed billing, shipping and billing are on 1 page
const Completed = () => import("@/pages/checkout/completed.vue");
const PaymentResult = () => import("@/pages/checkout/payment-result.vue");
const Payment = () => import("@/pages/checkout/payment.vue");
const InnoReview = () => import("@/pages/checkout/innovadis/inno-review.vue"); // Innovadis custom: review page
const InnoShippingAndBilling = () => import("@/pages/checkout/innovadis/inno-shipping-and-billing.vue"); // Innovadis custom: shipping and billing page

function handleBeforeEnter(
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
  targetRoute: RouteRecordName,
  redirectRoute: RouteRecordName,
) {
  if (from.name === targetRoute) {
    next({ name: redirectRoute, replace: true });
  } else {
    next();
  }
}
export const checkoutRoutes: RouteRecordRaw[] = [
  {
    path: "checkout/completed",
    name: "CheckoutCompleted",
    component: Completed,
    meta: { redirectable: false },
  },
  {
    path: "checkout/payment/:status(success|failure)",
    name: "CheckoutPaymentResult",
    component: PaymentResult,
    props: true,
    meta: { redirectable: false },
  },
  {
    path: "checkout",
    name: "Checkout",
    component: Checkout,
    children: [
      {
        path: "shipping",
        name: "Shipping",
        component: InnoShippingAndBilling,
        beforeEnter(to, from, next) {
          handleBeforeEnter(from, next, "CheckoutPayment", "Cart");
        },
      },
      // Innovadis custom: Removed billing, shipping and billing are on 1 page
      {
        path: "review",
        name: "Review",
        component: InnoReview,
      },
      {
        path: "payment",
        name: "CheckoutPayment",
        component: Payment,
      },
    ],
    meta: { layout: "Secure" },
    beforeEnter(to, from, next) {
      if (from.name === "Cart") {
        next();
      } else if (from.name === "CheckoutPaymentResult" && to.name === "CheckoutPayment") {
        next();
      } else {
        next({ name: "Cart", replace: true });
      }
    },
  },
];
